"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchRootSaga;
exports.fetchDepthDataByCountryIDSaga = fetchDepthDataByCountryIDSaga;
exports.setQuerySaga = setQuerySaga;
exports.validateQuerySaga = validateQuerySaga;
var _effects = require("redux-saga/effects");
var _reactRouter = require("react-router");
var _connectedReactRouter = require("connected-react-router");
var _immutable = require("immutable");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("@otpusk/apisearch-toolbox/dist/queries/actions");
var _saga = require("@otpusk/apisearch-toolbox/dist/queries/saga");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/search/actions");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _actions3 = require("@otpusk/apisearch-toolbox/dist/geo/actions");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _actions4 = require("@otpusk/apisearch-toolbox/dist/services/actions");
var _actions5 = require("@otpusk/apisearch-toolbox/dist/offers/actions");
var _hotels = require("@otpusk/apisearch-toolbox/dist/hotels");
var _localization = _interopRequireDefault(require("../../../localization"));
var _book = require("../../routes/book");
var _selectors4 = require("../../../bus/auth/selectors");
var _actions6 = require("../../../bus/stats/actions");
var _query = require("../../../helpers/query");
var _config = require("../../../services/config");
var _ConfirmModal = require("../../ConfirmModal");
var _actions7 = require("../components/GeoTreeControl/store/actions");
var _helpers2 = require("../components/TourViewControl/helpers");
var _saga2 = _interopRequireDefault(require("../components/CountryControl/store/saga"));
var _saga3 = _interopRequireDefault(require("../components/DepartureControl/store/saga"));
var _constants = require("../constants");
var _helpers3 = require("../helpers");
var _actions8 = require("./actions");
var _selectors5 = require("./selectors");
var _helpers4 = require("./helpers");
var _constants2 = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(getDefaultQuerySaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(openPageBySearchOfferIDSaga),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(handleUnmountedSearchFormSaga),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(searchRootSaga);
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function fetchDepthDataByCountryIDSaga(_ref) {
  var baseQueryID = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var countryID, rating, services, departuresIDs, shouldFetchHotelsByCountry;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.COUNTRY,
              queryID: baseQueryID
            });
          });
        case 2:
          countryID = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.AVERAGE_RATING,
              queryID: baseQueryID
            });
          });
        case 5:
          rating = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.SERVICES,
              queryID: baseQueryID
            });
          });
        case 8:
          services = _context.sent;
          _context.next = 11;
          return (0, _effects.select)(function (state) {
            return R.call(R.pipe(R.filter(function (queryID) {
              return Boolean((0, _selectors.getQuery)(state, {
                queryID: queryID
              }));
            }), R.map(function (queryID) {
              return (0, _selectors.getQueryParam)(state, {
                paramName: _fn.QUERY_PARAMS.DEPARTURES,
                queryID: queryID
              }).toArray()[0];
            })), _constants.MAIN_QUERIES);
          });
        case 11:
          departuresIDs = _context.sent;
          shouldFetchHotelsByCountry = !rating.isEmpty() || !services.isEmpty();
          _context.next = 15;
          return (0, _effects.all)([(0, _effects.put)(_actions3.geoActions.getDepartureCities(countryID, '2.6')), (0, _effects.put)((0, _actions7.getData)(countryID, true)), (0, _effects.put)((0, _actions8.getHotels)(countryID, rating.toJS(), services.toJS())), shouldFetchHotelsByCountry && (0, _effects.put)(_actions3.geoActions.getHotels(countryID, false)), (0, _effects.put)(_actions4.servicesActions.getServices(countryID))].concat(_toConsumableArray(R.map(function (departureID) {
            return (0, _effects.put)(_actions3.geoActions.getOperators(countryID, departureID, '2.6'));
          }, departuresIDs)), _toConsumableArray(R.map(function (departureID) {
            return (0, _effects.put)(_actions2.searchActions.getAvailableDates(countryID, departureID));
          }, departuresIDs))));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
}
function getDefaultQuerySaga() {
  var topCountry, _yield$select, defaultDepartureID, _yield$call, departureID, transport, baseQuery;
  return _regeneratorRuntime().wrap(function getDefaultQuerySaga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return (0, _effects.select)(_selectors3.getTopCountry);
      case 2:
        topCountry = _context3.sent;
        _context3.next = 5;
        return (0, _effects.select)(_selectors4.getSession);
      case 5:
        _yield$select = _context3.sent;
        defaultDepartureID = _yield$select.defaultDepartureID;
        _context3.next = 9;
        return (0, _effects.call)(/*#__PURE__*/_regeneratorRuntime().mark(function getDefaultDepartureDirectionWrapper() {
          var result, cities;
          return _regeneratorRuntime().wrap(function getDefaultDepartureDirectionWrapper$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _effects.call)(_saga.getDefaultDepartureDirection, {
                  defaultDepartureID: defaultDepartureID,
                  geoID: topCountry.id
                });
              case 2:
                result = _context2.sent;
                if (result) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 6;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors3.getDepartures)()(state, {
                    geoID: topCountry.id
                  });
                });
              case 6:
                cities = _context2.sent;
                result = (0, _query.getDepartureCityIDAndTransport)(cities);
              case 8:
                return _context2.abrupt("return", result);
              case 9:
              case "end":
                return _context2.stop();
            }
          }, getDefaultDepartureDirectionWrapper);
        }));
      case 9:
        _yield$call = _context3.sent;
        departureID = _yield$call.departureID;
        transport = _yield$call.transport;
        baseQuery = (0, _fn.createQuery)();
        return _context3.abrupt("return", (0, _fn.createQuery)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _fn.QUERY_PARAMS.DEPARTURES, baseQuery.get(_fn.QUERY_PARAMS.DEPARTURES).clear().push(departureID)), _fn.QUERY_PARAMS.COUNTRY, topCountry ? topCountry.id : null), _fn.QUERY_PARAMS.CURRENCY, (0, _helpers3.getCurrencyCodeFromLocalStorage)() || (0, _config.getInitialCurrencyCode)()), _fn.QUERY_PARAMS.DATES, (0, _immutable.Map)((0, _helpers4.getInitialDatesForQuery)())), _fn.QUERY_PARAMS.DURATION, (0, _immutable.Map)({
          from: 6,
          to: 8
        })), _fn.QUERY_PARAMS.TRANSPORTS, baseQuery.get(_fn.QUERY_PARAMS.TRANSPORTS).map(function (transportsMap) {
          return transportsMap.map(R.F).set(transport, true);
        })), _fn.QUERY_PARAMS.CATEGORY, (0, _immutable.Map)({
          1: false,
          2: false,
          3: false,
          4: true,
          5: true
        })), _fn.QUERY_PARAMS.FOOD, (0, _immutable.Map)({
          uai: true,
          ai: true,
          fb: false,
          hb: false,
          bb: false,
          ob: false,
          ro: false
        })), _fn.QUERY_PARAMS.FLIGHT_AVAILABILITY, (0, _immutable.Set)(['yes'])), _fn.QUERY_PARAMS.HOTEL_AVAILABILITY, (0, _immutable.Set)(['yes', 'request']))));
      case 14:
      case "end":
        return _context3.stop();
    }
  }, _marked);
}
function setQuerySaga(_ref2) {
  var queryID = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var baseQuery, departuresIDs, transports, _iterator, _step, _loop;
    return _regeneratorRuntime().wrap(function _callee2$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!global.location.search) {
            _context5.next = 4;
            break;
          }
          _context5.t0 = (0, _fn.parseQueryString)(global.location.search);
          _context5.next = 12;
          break;
        case 4:
          _context5.next = 6;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: queryID
            });
          });
        case 6:
          _context5.t1 = _context5.sent;
          if (_context5.t1) {
            _context5.next = 11;
            break;
          }
          _context5.next = 10;
          return (0, _effects.call)(getDefaultQuerySaga);
        case 10:
          _context5.t1 = _context5.sent;
        case 11:
          _context5.t0 = _context5.t1;
        case 12:
          baseQuery = _context5.t0;
          departuresIDs = baseQuery.get(_fn.QUERY_PARAMS.DEPARTURES).toArray();
          transports = baseQuery.get(_fn.QUERY_PARAMS.TRANSPORTS).toArray();
          _iterator = _createForOfIteratorHelper(departuresIDs.entries());
          _context5.prev = 16;
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var _step$value, index, departureID, query;
            return _regeneratorRuntime().wrap(function _loop$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], departureID = _step$value[1];
                  query = baseQuery.update(_fn.QUERY_PARAMS.DEPARTURES, function (list) {
                    return list.clear().push(departureID);
                  }).update(_fn.QUERY_PARAMS.TRANSPORTS, function (list) {
                    return list.clear().push(transports[index]);
                  });
                  _context4.next = 4;
                  return (0, _effects.put)(_actions.queriesActions.setQuery(_constants.MAIN_QUERIES[index], (0, _helpers4.handleEmptyQueryParams)(query)));
                case 4:
                case "end":
                  return _context4.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 19:
          if ((_step = _iterator.n()).done) {
            _context5.next = 23;
            break;
          }
          return _context5.delegateYield(_loop(), "t2", 21);
        case 21:
          _context5.next = 19;
          break;
        case 23:
          _context5.next = 28;
          break;
        case 25:
          _context5.prev = 25;
          _context5.t3 = _context5["catch"](16);
          _iterator.e(_context5.t3);
        case 28:
          _context5.prev = 28;
          _iterator.f();
          return _context5.finish(28);
        case 31:
        case "end":
          return _context5.stop();
      }
    }, _callee2, null, [[16, 25, 28, 31]]);
  })();
}
function resetFormSaga(_ref3) {
  var baseQueryID = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var setQueries, _iterator2, _step2, _loop2, defaultQuery;
    return _regeneratorRuntime().wrap(function _callee3$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(function (state) {
            return R.filter(function (queryID) {
              return Boolean((0, _selectors.getQuery)(state, {
                queryID: queryID
              }));
            }, _constants.MAIN_QUERIES);
          });
        case 2:
          setQueries = _context7.sent;
          _iterator2 = _createForOfIteratorHelper(setQueries);
          _context7.prev = 4;
          _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
            var queryID, shouldCancelSearch, isBase;
            return _regeneratorRuntime().wrap(function _loop2$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  queryID = _step2.value;
                  _context6.next = 3;
                  return (0, _effects.select)(function (state) {
                    return (0, _selectors2.isProccess)(state, {
                      queryID: queryID
                    });
                  });
                case 3:
                  shouldCancelSearch = _context6.sent;
                  if (!shouldCancelSearch) {
                    _context6.next = 7;
                    break;
                  }
                  _context6.next = 7;
                  return (0, _effects.put)(_actions2.searchActions.cancelledSearch(queryID));
                case 7:
                  _context6.next = 9;
                  return (0, _effects.put)(_actions2.searchActions.clearSearch(queryID));
                case 9:
                  isBase = queryID === baseQueryID;
                  if (isBase) {
                    _context6.next = 13;
                    break;
                  }
                  _context6.next = 13;
                  return (0, _effects.put)(_actions.queriesActions.removeQuery(queryID));
                case 13:
                case "end":
                  return _context6.stop();
              }
            }, _loop2);
          });
          _iterator2.s();
        case 7:
          if ((_step2 = _iterator2.n()).done) {
            _context7.next = 11;
            break;
          }
          return _context7.delegateYield(_loop2(), "t0", 9);
        case 9:
          _context7.next = 7;
          break;
        case 11:
          _context7.next = 16;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t1 = _context7["catch"](4);
          _iterator2.e(_context7.t1);
        case 16:
          _context7.prev = 16;
          _iterator2.f();
          return _context7.finish(16);
        case 19:
          _context7.next = 21;
          return (0, _effects.call)(getDefaultQuerySaga);
        case 21:
          defaultQuery = _context7.sent;
          _context7.next = 24;
          return (0, _effects.put)(_actions.queriesActions.setQuery(baseQueryID, defaultQuery));
        case 24:
          _context7.next = 26;
          return (0, _effects.put)((0, _connectedReactRouter.push)(_book.book.search));
        case 26:
          _context7.next = 28;
          return (0, _effects.put)((0, _actions8.fetchDepthDataByCountryID)(baseQueryID));
        case 28:
          _context7.next = 30;
          return (0, _effects.put)((0, _actions8.clearSearchHotelsString)());
        case 30:
          _context7.next = 32;
          return (0, _effects.put)((0, _actions8.clearSearchOfferID)());
        case 32:
        case "end":
          return _context7.stop();
      }
    }, _callee3, null, [[4, 13, 16, 19]]);
  })();
}
function validateQuerySaga(queryID) {
  var withNotification = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var query, errors;
    return _regeneratorRuntime().wrap(function _callee4$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: queryID
            });
          });
        case 2:
          query = _context8.sent;
          errors = R.map(_localization.default.t, (0, _helpers4.getErrorsByQuery)(query.toJS()));
          if (!R.isEmpty(errors) && withNotification) {
            global.window.alert(R.join('. ', errors));
          }
          return _context8.abrupt("return", {
            isValid: R.isEmpty(errors),
            errors: errors
          });
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee4);
  })();
}
function searchSaga(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var baseQueryID, values, _iterator3, _step3, _loop3, _iterator4, _step4, _loop4, _yield$call2, isValid, baseQueryForURL, searchStringAsQuery, shouldRewriteSearchParams, setQueries, _iterator5, _step5, queryID, statuses, _iterator6, _step6, status, _status, isFailSearch, failHandler, isInternetConnectionLost;
    return _regeneratorRuntime().wrap(function _callee5$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          baseQueryID = payload.queryID, values = payload.values;
          _iterator3 = _createForOfIteratorHelper(_constants.MAIN_QUERIES.entries());
          _context11.prev = 2;
          _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
            var _step3$value, index, queryID, shouldCancelSearch, isSetQuery, isLastQuery;
            return _regeneratorRuntime().wrap(function _loop3$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _step3$value = _slicedToArray(_step3.value, 2), index = _step3$value[0], queryID = _step3$value[1];
                  _context9.next = 3;
                  return (0, _effects.select)(function (state) {
                    return (0, _selectors2.isProccess)(state, {
                      queryID: queryID
                    });
                  });
                case 3:
                  shouldCancelSearch = _context9.sent;
                  if (!shouldCancelSearch) {
                    _context9.next = 7;
                    break;
                  }
                  _context9.next = 7;
                  return (0, _effects.put)(_actions2.searchActions.cancelledSearch(queryID));
                case 7:
                  _context9.next = 9;
                  return (0, _effects.put)(_actions2.searchActions.clearSearch(queryID));
                case 9:
                  _context9.next = 11;
                  return (0, _effects.delay)(1);
                case 11:
                  isSetQuery = R.has(index, values[_fn.QUERY_PARAMS.DEPARTURES]); // need to save first query
                  _context9.next = 14;
                  return (0, _effects.select)(function (state) {
                    var count = R.length(R.filter(function (id) {
                      return Boolean((0, _selectors.getQuery)(state, {
                        queryID: id
                      }));
                    }, _constants.MAIN_QUERIES));
                    return count === 1;
                  });
                case 14:
                  isLastQuery = _context9.sent;
                  if (!(!isSetQuery && !isLastQuery)) {
                    _context9.next = 18;
                    break;
                  }
                  _context9.next = 18;
                  return (0, _effects.put)(_actions.queriesActions.removeQuery(_constants.MAIN_QUERIES[index]));
                case 18:
                case "end":
                  return _context9.stop();
              }
            }, _loop3);
          });
          _iterator3.s();
        case 5:
          if ((_step3 = _iterator3.n()).done) {
            _context11.next = 9;
            break;
          }
          return _context11.delegateYield(_loop3(), "t0", 7);
        case 7:
          _context11.next = 5;
          break;
        case 9:
          _context11.next = 14;
          break;
        case 11:
          _context11.prev = 11;
          _context11.t1 = _context11["catch"](2);
          _iterator3.e(_context11.t1);
        case 14:
          _context11.prev = 14;
          _iterator3.f();
          return _context11.finish(14);
        case 17:
          if (!R.isEmpty(values[_fn.QUERY_PARAMS.DEPARTURES])) {
            _context11.next = 22;
            break;
          }
          _context11.next = 20;
          return (0, _effects.put)(_actions.queriesActions.changeQueryParam(_constants.MAIN_QUERY_ID, _fn.QUERY_PARAMS.DEPARTURES, values[_fn.QUERY_PARAMS.DEPARTURES]));
        case 20:
          _context11.next = 22;
          return (0, _effects.put)(_actions.queriesActions.changeQueryParam(_constants.MAIN_QUERY_ID, _fn.QUERY_PARAMS.TRANSPORTS, values[_fn.QUERY_PARAMS.TRANSPORTS]));
        case 22:
          _iterator4 = _createForOfIteratorHelper(values[_fn.QUERY_PARAMS.DEPARTURES].entries());
          _context11.prev = 23;
          _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop4() {
            var _step4$value, index, departureID, transports, queryID, query;
            return _regeneratorRuntime().wrap(function _loop4$(_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  _step4$value = _slicedToArray(_step4.value, 2), index = _step4$value[0], departureID = _step4$value[1];
                  transports = values[_fn.QUERY_PARAMS.TRANSPORTS][index];
                  queryID = _constants.MAIN_QUERIES[index];
                  query = (0, _fn.createQuery)().map(function (value, key) {
                    return (0, _immutable.isImmutable)(value) ? value.merge(values[key]) : values[key] || value;
                  }).update(_fn.QUERY_PARAMS.TRANSPORTS, function (list) {
                    return list.clear().push((0, _immutable.Map)(transports));
                  }).set(_fn.QUERY_PARAMS.GROUP, (0, _helpers4.getGroupQueryParamByHotelsCount)(values[_fn.QUERY_PARAMS.HOTELS].length)).set(_fn.QUERY_PARAMS.PAGE, 1).set(_fn.QUERY_PARAMS.AUTOSTART, true).update(_fn.QUERY_PARAMS.DEPARTURES, function (list) {
                    return list.clear().push(departureID);
                  });
                  _context10.next = 6;
                  return (0, _effects.put)(_actions.queriesActions.setQuery(queryID, query));
                case 6:
                case "end":
                  return _context10.stop();
              }
            }, _loop4);
          });
          _iterator4.s();
        case 26:
          if ((_step4 = _iterator4.n()).done) {
            _context11.next = 30;
            break;
          }
          return _context11.delegateYield(_loop4(), "t2", 28);
        case 28:
          _context11.next = 26;
          break;
        case 30:
          _context11.next = 35;
          break;
        case 32:
          _context11.prev = 32;
          _context11.t3 = _context11["catch"](23);
          _iterator4.e(_context11.t3);
        case 35:
          _context11.prev = 35;
          _iterator4.f();
          return _context11.finish(35);
        case 38:
          _context11.next = 40;
          return (0, _effects.call)(validateQuerySaga, baseQueryID, true);
        case 40:
          _yield$call2 = _context11.sent;
          isValid = _yield$call2.isValid;
          if (!isValid) {
            _context11.next = 105;
            break;
          }
          _context11.next = 45;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: baseQueryID
            }).update(_fn.QUERY_PARAMS.DEPARTURES, function (list) {
              return list.clear().merge(values[_fn.QUERY_PARAMS.DEPARTURES]);
            }).update(_fn.QUERY_PARAMS.TRANSPORTS, function (list) {
              return list.clear().merge(values[_fn.QUERY_PARAMS.TRANSPORTS]).map(function (transport) {
                return (0, _immutable.Map)(transport);
              });
            });
          });
        case 45:
          baseQueryForURL = _context11.sent;
          _context11.next = 48;
          return (0, _effects.select)(R.pipe(_connectedReactRouter.getSearch, function (string) {
            return (0, _fn.parseQueryString)(string);
          }));
        case 48:
          searchStringAsQuery = _context11.sent;
          shouldRewriteSearchParams = !R.equals((0, _fn.compileSearchQuery)(baseQueryForURL), (0, _fn.compileSearchQuery)(searchStringAsQuery));
          if (!shouldRewriteSearchParams) {
            _context11.next = 53;
            break;
          }
          _context11.next = 53;
          return (0, _effects.put)((0, _connectedReactRouter.push)(R.concat(_book.book.search, (0, _fn.compileSearchQuery)((0, _fn.createQuery)(baseQueryForURL)))));
        case 53:
          _context11.next = 55;
          return (0, _effects.select)(function (state) {
            return R.filter(function (queryID) {
              return Boolean((0, _selectors.getQuery)(state, {
                queryID: queryID
              }));
            }, _constants.MAIN_QUERIES);
          });
        case 55:
          setQueries = _context11.sent;
          _iterator5 = _createForOfIteratorHelper(setQueries);
          _context11.prev = 57;
          _iterator5.s();
        case 59:
          if ((_step5 = _iterator5.n()).done) {
            _context11.next = 65;
            break;
          }
          queryID = _step5.value;
          _context11.next = 63;
          return (0, _effects.put)(_actions2.searchActions.getResults(queryID));
        case 63:
          _context11.next = 59;
          break;
        case 65:
          _context11.next = 70;
          break;
        case 67:
          _context11.prev = 67;
          _context11.t4 = _context11["catch"](57);
          _iterator5.e(_context11.t4);
        case 70:
          _context11.prev = 70;
          _iterator5.f();
          return _context11.finish(70);
        case 73:
          _context11.next = 75;
          return (0, _effects.put)((0, _actions6.logSearch)());
        case 75:
          _context11.next = 77;
          return (0, _effects.all)(R.map(function (queryID) {
            return (0, _effects.race)([(0, _effects.take)(function (action) {
              return action.type === _actions2.searchActions.failSearch.toString() && action.payload === queryID;
            }), (0, _effects.take)(function (action) {
              return action.type === _actions2.searchActions.finishSearch.toString() && action.payload.queryId === queryID;
            }), (0, _effects.take)(function (action) {
              return action.type === _actions2.searchActions.cancelledSearch.toString() && action.payload === queryID;
            })]);
          }, setQueries));
        case 77:
          statuses = _context11.sent;
          _iterator6 = _createForOfIteratorHelper(statuses);
          _context11.prev = 79;
          _iterator6.s();
        case 81:
          if ((_step6 = _iterator6.n()).done) {
            _context11.next = 97;
            break;
          }
          status = _step6.value;
          _status = _slicedToArray(status, 1), isFailSearch = _status[0];
          if (!isFailSearch) {
            _context11.next = 95;
            break;
          }
          failHandler = (0, _config.getOnFailSearch)();
          if (failHandler) {
            failHandler(isFailSearch.meta.response);
          }
          isInternetConnectionLost = isFailSearch.meta.error.message === 'Failed to fetch';
          if (!isInternetConnectionLost) {
            _context11.next = 92;
            break;
          }
          global.alert(_localization.default.t('API_REQUESTS_ERRORS:INTERNET_CONNECTION_IS_LOST'));
          _context11.next = 94;
          break;
        case 92:
          _context11.next = 94;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            content: isFailSearch.meta.response.message,
            header: _localization.default.t(isFailSearch.meta.response.statusCode === 400 ? 'SEARCH_FORM:SEARCH_ERROR_WITH_INVALID_PARAMS' : 'SEARCH_FORM:SEARCH_ERROR_WITH_API_UP_TIME'),
            cancelButton: false
          }));
        case 94:
          return _context11.abrupt("break", 97);
        case 95:
          _context11.next = 81;
          break;
        case 97:
          _context11.next = 102;
          break;
        case 99:
          _context11.prev = 99;
          _context11.t5 = _context11["catch"](79);
          _iterator6.e(_context11.t5);
        case 102:
          _context11.prev = 102;
          _iterator6.f();
          return _context11.finish(102);
        case 105:
        case "end":
          return _context11.stop();
      }
    }, _callee5, null, [[2, 11, 14, 17], [23, 32, 35, 38], [57, 67, 70, 73], [79, 99, 102, 105]]);
  })();
}
function handleBrowserBackSaga(_ref5) {
  var queryID = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var searchStringAsQuery, combinedMainQuery, shoulRefreshSearch, searchString, _iterator7, _step7, id, combinedQuery, defaultQuery, _iterator8, _step8, _id;
    return _regeneratorRuntime().wrap(function _callee6$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          if (!true) {
            _context12.next = 71;
            break;
          }
          _context12.next = 3;
          return (0, _effects.take)(function (action) {
            return R.all(Boolean, [action.type === _connectedReactRouter.LOCATION_CHANGE, R.path(['payload', 'action'], action) === 'POP', R.path(['payload', 'location', 'pathname'], action) === _book.book.search]);
          });
        case 3:
          _context12.next = 5;
          return (0, _effects.select)(R.pipe(_connectedReactRouter.getSearch, decodeURIComponent, function (string) {
            return (0, _fn.parseQueryString)(string);
          }));
        case 5:
          searchStringAsQuery = _context12.sent;
          _context12.next = 8;
          return (0, _effects.select)(_selectors5.getCombinedMainQueries);
        case 8:
          combinedMainQuery = _context12.sent;
          shoulRefreshSearch = !R.equals((0, _fn.compileSearchQuery)(combinedMainQuery), (0, _fn.compileSearchQuery)(searchStringAsQuery));
          if (!shoulRefreshSearch) {
            _context12.next = 69;
            break;
          }
          _context12.next = 13;
          return (0, _effects.select)(_connectedReactRouter.getSearch);
        case 13:
          searchString = _context12.sent;
          if (!searchString) {
            _context12.next = 43;
            break;
          }
          // without main id
          _iterator7 = _createForOfIteratorHelper(R.without([queryID], _constants.MAIN_QUERIES));
          _context12.prev = 16;
          _iterator7.s();
        case 18:
          if ((_step7 = _iterator7.n()).done) {
            _context12.next = 26;
            break;
          }
          id = _step7.value;
          _context12.next = 22;
          return (0, _effects.put)(_actions2.searchActions.clearSearch(id));
        case 22:
          _context12.next = 24;
          return (0, _effects.put)(_actions.queriesActions.removeQuery(id));
        case 24:
          _context12.next = 18;
          break;
        case 26:
          _context12.next = 31;
          break;
        case 28:
          _context12.prev = 28;
          _context12.t0 = _context12["catch"](16);
          _iterator7.e(_context12.t0);
        case 31:
          _context12.prev = 31;
          _iterator7.f();
          return _context12.finish(31);
        case 34:
          _context12.next = 36;
          return (0, _effects.call)(setQuerySaga, (0, _actions8.setQuery)(queryID));
        case 36:
          _context12.next = 38;
          return (0, _effects.select)(_selectors5.getCombinedMainQueries);
        case 38:
          combinedQuery = _context12.sent;
          _context12.next = 41;
          return (0, _effects.put)((0, _actions8.search)(queryID, combinedQuery.toJS()));
        case 41:
          _context12.next = 69;
          break;
        case 43:
          _context12.next = 45;
          return (0, _effects.call)(getDefaultQuerySaga);
        case 45:
          defaultQuery = _context12.sent;
          _context12.next = 48;
          return (0, _effects.put)(_actions.queriesActions.setQuery(queryID, defaultQuery));
        case 48:
          _context12.next = 50;
          return (0, _effects.put)(_actions2.searchActions.clearSearch(queryID));
        case 50:
          // without main id
          _iterator8 = _createForOfIteratorHelper(R.without([queryID], _constants.MAIN_QUERIES));
          _context12.prev = 51;
          _iterator8.s();
        case 53:
          if ((_step8 = _iterator8.n()).done) {
            _context12.next = 61;
            break;
          }
          _id = _step8.value;
          _context12.next = 57;
          return (0, _effects.put)(_actions2.searchActions.clearSearch(_id));
        case 57:
          _context12.next = 59;
          return (0, _effects.put)(_actions.queriesActions.removeQuery(_id));
        case 59:
          _context12.next = 53;
          break;
        case 61:
          _context12.next = 66;
          break;
        case 63:
          _context12.prev = 63;
          _context12.t1 = _context12["catch"](51);
          _iterator8.e(_context12.t1);
        case 66:
          _context12.prev = 66;
          _iterator8.f();
          return _context12.finish(66);
        case 69:
          _context12.next = 0;
          break;
        case 71:
        case "end":
          return _context12.stop();
      }
    }, _callee6, null, [[16, 28, 31, 34], [51, 63, 66, 69]]);
  })();
}
function openPageBySearchOfferIDSaga() {
  var searchOfferID, _yield$race, _yield$race2, setOfferAction, offer;
  return _regeneratorRuntime().wrap(function openPageBySearchOfferIDSaga$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        _context13.next = 2;
        return (0, _effects.select)(_selectors5.getSearchOfferID);
      case 2:
        searchOfferID = _context13.sent;
        if (!(searchOfferID.length < 6)) {
          _context13.next = 7;
          break;
        }
        (0, _helpers2.getTourViewControlInput)().focus();
        _context13.next = 23;
        break;
      case 7:
        _context13.next = 9;
        return (0, _effects.put)(_actions5.offersActions.getOffer(searchOfferID));
      case 9:
        _context13.next = 11;
        return (0, _effects.race)([(0, _effects.take)(_actions5.offersActions.setOffer), (0, _effects.take)(_actions5.offersActions.getOfferFail)]);
      case 11:
        _yield$race = _context13.sent;
        _yield$race2 = _slicedToArray(_yield$race, 1);
        setOfferAction = _yield$race2[0];
        if (!setOfferAction) {
          _context13.next = 21;
          break;
        }
        offer = setOfferAction.payload.offer;
        _context13.next = 18;
        return (0, _effects.put)((0, _actions8.clearSearchOfferID)());
      case 18:
        global.open((0, _reactRouter.generatePath)(_book.book.offer, {
          hotelID: offer.hotelId,
          offerID: offer.id
        }), '_blank');
        _context13.next = 23;
        break;
      case 21:
        _context13.next = 23;
        return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
          header: _localization.default.t('SEARCH_FORM:OFFER_NOT_FOUND_INFO'),
          cancelButton: false,
          confirmButtonText: _localization.default.t('SEARCH_FORM:OFFER_NOT_FOUND_CONFIRM_MODAL_BUTTON')
        }));
      case 23:
      case "end":
        return _context13.stop();
    }
  }, _marked2);
}
function getHotelsSaga(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var countryID, rating, services, hotelKeyByParams;
    return _regeneratorRuntime().wrap(function _callee7$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          countryID = payload.countryID, rating = payload.rating, services = payload.services;
          hotelKeyByParams = (0, _helpers.generateHotelKey)(countryID, rating, services);
          _context14.next = 4;
          return (0, _effects.put)((0, _actions8.setLoadingHotels)(true));
        case 4:
          _context14.next = 6;
          return (0, _effects.put)(_actions3.geoActions.getHotels(countryID, false, services, rating, _constants2.GET_HOTELS_METHOD_VERSION));
        case 6:
          _context14.next = 8;
          return (0, _effects.race)([(0, _effects.take)(function (action) {
            return R.and(action.type === _actions3.geoActions.getHotelsSuccess.toString(), R.prop('key', action.payload) === hotelKeyByParams);
          }), (0, _effects.take)(_actions3.geoActions.getHotelsFail)]);
        case 8:
          _context14.next = 10;
          return (0, _effects.put)((0, _actions8.setLoadingHotels)(false));
        case 10:
        case "end":
          return _context14.stop();
      }
    }, _callee7);
  })();
}
function handleUnmountedSearchFormSaga() {
  var setQueries, _iterator9, _step9, _loop5;
  return _regeneratorRuntime().wrap(function handleUnmountedSearchFormSaga$(_context16) {
    while (1) switch (_context16.prev = _context16.next) {
      case 0:
        _context16.next = 2;
        return (0, _effects.select)(function (state) {
          return R.filter(function (queryID) {
            return Boolean((0, _selectors.getQuery)(state, {
              queryID: queryID
            }));
          }, _constants.MAIN_QUERIES);
        });
      case 2:
        setQueries = _context16.sent;
        _iterator9 = _createForOfIteratorHelper(setQueries);
        _context16.prev = 4;
        _loop5 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop5() {
          var queryID, shouldCancelSearch;
          return _regeneratorRuntime().wrap(function _loop5$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                queryID = _step9.value;
                _context15.next = 3;
                return (0, _effects.select)(function (state) {
                  return (0, _selectors2.isProccess)(state, {
                    queryID: queryID
                  });
                });
              case 3:
                shouldCancelSearch = _context15.sent;
                if (!shouldCancelSearch) {
                  _context15.next = 7;
                  break;
                }
                _context15.next = 7;
                return (0, _effects.put)(_actions2.searchActions.cancelledSearch(queryID));
              case 7:
                _context15.next = 9;
                return (0, _effects.put)(_actions2.searchActions.clearSearch(queryID));
              case 9:
              case "end":
                return _context15.stop();
            }
          }, _loop5);
        });
        _iterator9.s();
      case 7:
        if ((_step9 = _iterator9.n()).done) {
          _context16.next = 11;
          break;
        }
        return _context16.delegateYield(_loop5(), "t0", 9);
      case 9:
        _context16.next = 7;
        break;
      case 11:
        _context16.next = 16;
        break;
      case 13:
        _context16.prev = 13;
        _context16.t1 = _context16["catch"](4);
        _iterator9.e(_context16.t1);
      case 16:
        _context16.prev = 16;
        _iterator9.f();
        return _context16.finish(16);
      case 19:
        _context16.next = 21;
        return (0, _effects.put)(_actions5.offersActions.resetOffersStore());
      case 21:
        _context16.next = 23;
        return (0, _effects.put)(_hotels.hotelsActions.resetHotelsStore());
      case 23:
        _context16.next = 25;
        return (0, _effects.put)((0, _actions8.endListenBrowserBackAction)());
      case 25:
      case "end":
        return _context16.stop();
    }
  }, _marked3, null, [[4, 13, 16, 19]]);
}
var withSearchThrottleSaga = function withSearchThrottleSaga(wrappSearchSaga) {
  return /*#__PURE__*/_regeneratorRuntime().mark(function withSearchThrottleWrapperSaga(action) {
    var isActualNextTime;
    return _regeneratorRuntime().wrap(function withSearchThrottleWrapperSaga$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(R.compose(_helpers4.isActualSearchTimestamp, _selectors5.getNextAvailableSearchTime));
        case 2:
          isActualNextTime = _context17.sent;
          if (isActualNextTime) {
            _context17.next = 8;
            break;
          }
          _context17.next = 6;
          return (0, _effects.put)((0, _actions8.setNextAvailableSearchTime)((0, _helpers4.generateNextAvailableSearchTime)()));
        case 6:
          _context17.next = 8;
          return (0, _effects.call)(wrappSearchSaga, action);
        case 8:
        case "end":
          return _context17.stop();
      }
    }, withSearchThrottleWrapperSaga);
  });
};
function searchRootSaga() {
  return _regeneratorRuntime().wrap(function searchRootSaga$(_context19) {
    while (1) switch (_context19.prev = _context19.next) {
      case 0:
        _context19.next = 2;
        return (0, _effects.all)([(0, _effects.takeEvery)(_actions8.resetForm, resetFormSaga), (0, _effects.takeEvery)(_actions8.setQuery, setQuerySaga), (0, _effects.takeEvery)(_actions8.search, withSearchThrottleSaga(searchSaga)), (0, _effects.takeEvery)(_actions8.fetchDepthDataByCountryID, fetchDepthDataByCountryIDSaga), (0, _effects.takeEvery)(_actions8.startListentBrowserBackAction, /*#__PURE__*/_regeneratorRuntime().mark(function handleBrowserBackProxySaga(action) {
          var forkedHandler;
          return _regeneratorRuntime().wrap(function handleBrowserBackProxySaga$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return (0, _effects.fork)(handleBrowserBackSaga, action);
              case 2:
                forkedHandler = _context18.sent;
                _context18.next = 5;
                return (0, _effects.take)(_actions8.endListenBrowserBackAction);
              case 5:
                _context18.next = 7;
                return (0, _effects.cancel)(forkedHandler);
              case 7:
              case "end":
                return _context18.stop();
            }
          }, handleBrowserBackProxySaga);
        })), (0, _effects.takeEvery)(_actions8.openPageBySearchOfferID, openPageBySearchOfferIDSaga), (0, _effects.takeEvery)(_actions8.getHotels, getHotelsSaga), (0, _effects.takeEvery)(_actions8.trackUnmountedSearchForm, handleUnmountedSearchFormSaga), (0, _saga2.default)(), (0, _saga3.default)()]);
      case 2:
      case "end":
        return _context19.stop();
    }
  }, _marked4);
}